import { DraftSadmEntityChangeset } from './draft-sadm-entity-changeset';
import { SadmEntityChangeset } from './sadm-entity-changeset';

/**
 * Narrows a changeset to its draft variant. `sadmEntityId` can't act as a compiler discriminant
 * (the saved variant's `number` is not a literal type), so callers narrow through this guard.
 */
export const isDraftSadmEntityChangeset = (changeset: SadmEntityChangeset): changeset is DraftSadmEntityChangeset =>
  changeset.sadmEntityId === null;
